// extracted by mini-css-extract-plugin
export default {"vlButton":"style_vlButton__RqyuC","secondary":"style_secondary__bNg7H","gradient":"style_gradient__xns9G"};